
/**
 * createReducer
 *
 * @param {object} _initialState
 * @param {object} _reducer
 *
 * Example _initialState:
 * const initState = {
 *  a: 2,
 *  b: 3,
 *  c: 4,
 *  d: 5
 * }
 *
 * Example _reducer:
 * const reducerObj = {
 *  [ADD_TO_A]: (prevState, payload) => ({ a: prevState.a + payload }),
 *  [POWER_OF_B]: (prevState) => ({ b: prevState.b * prevState.b }),
 *  [C_IS_TWELVE]: { c: 12 }
 * }
 *
 * ADD_TO_A, POWER_OF_B, C_IS_TWELVE is a constant type, action type.
 *
 * reducerObj must be an object with every value of its property is a function or a plain object
 * createReducer will match
 * If it's a function, it will be receive 2 parameter, prevState and payload.
 * You can access your previous state via prevState, first parameter.
 * Also access payload from dispatched object via payload
 * It's prevState and payload from the action.
 *
 * Pay attention that you don't need to spread and return the prevState again
 * It will be handled by the function.
 * Just change the value of which state you want to update.
 *
 * If you decide to do some kind of magic in the reducerObj go ahead and customize your function
 * example:
 * const reducerObj = {
 *  [DO_SOME_MAGIC_TO_A]: (prevState, payload) => {
 *    // do some complex magic
 *    return { a: 9999 }
 *  },
 *  // ... another handler
 * }
 *
 * Usage:
 * const rootReducer = combineReducers({
 *  MyReducer: createReducer(initState, reducerObj)
 * })
 *
 * createReducer is just a high-order function that will return a function with state and action parameter,
 * just like normal reducer. So, you don't need to re-code every switch case or spread your previous state in every possible action.
 */

export default function createReducer(_initialState, _reducer) {
  return (state = _initialState, action) => {
    const reducer = _reducer;

    if ((Object.prototype.hasOwnProperty.call(reducer, action.type)
          && typeof reducer[action.type] === 'function')
        || typeof reducer[action.type] === 'object') {

      const updated = (typeof reducer[action.type] === 'function')
        ? (reducer[action.type])(state, action.payload)
        : reducer[action.type];

      if (state instanceof Array) {
        return [...state, ...updated];
      }

      return { ...state, ...updated };
    }

    return state;
  };
}
